import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  itemWrapper: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '25px',
  },
  itemRow: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '17px',
  },
  deleteIcon: {

    width: '16px',
  },
  item: {
    display: 'flex',
    alignItems: 'center',
    padding: '10px',
    height: '56px',
    width: '94%',
    [theme.breakpoints.down(1180)]: {
      width: 'auto',
    },
    borderRadius: '7px',
    background: '#FFF',
    boxShadow: '0px 2px 5px 0px rgba(0, 0, 0, 0.07)',
  },
  itemTitle: {
    fontSize: '12px',
    fontWeight: 600,
    color: theme.palette.primary.primary800,
    marginBottom: '10px',
  },
  contextWrapper: {
    display: 'flex',
    flexDirection: 'column',
  },
  tiersList: {
    maxHeight: '350px',
    overflow: 'auto',
  },
  tpName: {
    fontSize: '14px',
    fontWeight: 600,
    color: theme.palette.primary.primary800,
    maxWidth: '280px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  tpActivity: {
    fontSize: '10px',
    color: theme.palette.grey.grey400,
    width: '220px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
}));

export default useStyles;
